import { render, staticRenderFns } from "./AmenityDetails.vue?vue&type=template&id=288d73c7&"
import script from "./AmenityDetails.vue?vue&type=script&lang=js&"
export * from "./AmenityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports